// tobe AI 앱의 컬러 시스템
export const colors = {
    // Primary Colors
    primary: '#2480FF',
    primaryLight: '#4A9AFF',
    primaryDark: '#1A5FCC',

    // Secondary Colors
    secondary: '#70737C',
    secondaryLight: '#9A9CA3',
    secondaryDark: '#4A4C52',

    // Background Colors
    background: '#FFFFFF',
    backgroundSecondary: '#F7F7F8',
    backgroundTertiary: '#F0F0F0',

    // Text Colors
    textPrimary: '#171719',
    textSecondary: '#70737C',
    textTertiary: '#9A9CA3',
    textDisabled: '#C7C8CC',

    // Border Colors
    borderPrimary: '#E5E5E7',
    borderSecondary: '#EAEBEC',
    borderLight: 'rgba(112, 115, 124, 0.16)',

    // Status Colors
    success: '#00B894',
    warning: '#FFA726',
    error: '#E52222',
    info: '#2480FF',

    // Action Colors
    buy: '#E52222',
    sell: '#136BF5',
    neutral: '#70737C',

    // Social Colors
    kakao: '#FEE500',
    kakaoText: '#191919',

    // Shadow Colors
    shadowLight: 'rgba(0, 0, 0, 0.03)',
    shadowMedium: 'rgba(0, 0, 0, 0.12)',
    shadowDark: 'rgba(0, 0, 0, 0.2)',

    // Gradient
    gradient: 'linear-gradient(135deg, #2480FF 0%, #4A9AFF 100%)',
} as const;

export type ColorKey = keyof typeof colors; 